"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash"));

var _smoothscrollPolyfill = _interopRequireDefault(require("smoothscroll-polyfill"));

var _svg = _interopRequireDefault(require("../svg"));

require("./horizontal-scroll.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Horizontal Scroller that utilizes the native scroll behaviour and allows smooth scrolling
 * with smoothscroll polyfill. Horizontal Scroll makes a best guess for scroll distances by
 * dividing the total scroll area by the length of the children array passed. This works under the
 * assumption that children are equally sized and evenly spaced.
 */
var HorizontalScroll = /*#__PURE__*/function (_Component) {
  _inherits(HorizontalScroll, _Component);

  var _super = _createSuper(HorizontalScroll);

  function HorizontalScroll(props) {
    var _this;

    _classCallCheck(this, HorizontalScroll);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setScrollRef", function (scrollArea) {
      if (!scrollArea) return;
      _this.scrollArea = scrollArea;
      var _this$props = _this.props,
          children = _this$props.children,
          scrollStepMultiply = _this$props.scrollStepMultiply; // Make best guess for element widths: total scroll width / total number of children

      _this.scrollStepWidth = Math.ceil(scrollArea.scrollWidth / children.length) * scrollStepMultiply;

      _this.handleScroll();
    });

    _this.state = {
      showBackArrow: false,
      showForwardArrow: false
    };
    _this.moveBack = _this.moveBack.bind(_assertThisInitialized(_this));
    _this.moveForward = _this.moveForward.bind(_assertThisInitialized(_this));
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    _this.throttledHandleScroll = _lodash["default"].throttle(_this.handleScroll, 200);
    return _this;
  }

  _createClass(HorizontalScroll, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // polyfill smooth scrolling api
      // https://github.com/iamdustan/smoothscroll
      _smoothscrollPolyfill["default"].polyfill();
    }
  }, {
    key: "moveBack",
    value: function moveBack() {
      this.scrollArea.scrollBy({
        top: 0,
        left: -1 * this.scrollStepWidth,
        behavior: 'smooth'
      });
    }
  }, {
    key: "moveForward",
    value: function moveForward() {
      this.scrollArea.scrollBy({
        top: 0,
        left: this.scrollStepWidth,
        behavior: 'smooth'
      });
    }
    /**
     * Throttled handle scroll. Is throttled in constructor.
     */

  }, {
    key: "handleScroll",
    value: function handleScroll() {
      var _this$scrollArea = this.scrollArea,
          scrollWidth = _this$scrollArea.scrollWidth,
          scrollLeft = _this$scrollArea.scrollLeft,
          offsetWidth = _this$scrollArea.offsetWidth;
      var scrolledLeft = scrollLeft < 10;
      var scrolledRight = scrollLeft > scrollWidth - offsetWidth - 10;
      this.setState({
        showForwardArrow: !scrolledRight,
        showBackArrow: !scrolledLeft
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          showBackArrow = _this$state.showBackArrow,
          showForwardArrow = _this$state.showForwardArrow;
      var showMobileArrows = this.props.showMobileArrows;

      var backArrow = /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('arrow back', {
          visible: showBackArrow
        }),
        onKeyPress: this.moveBack,
        onClick: this.moveBack,
        role: "button",
        tabIndex: "0"
      }, /*#__PURE__*/_react["default"].createElement(_svg["default"], {
        id: "chevron-light"
      }));

      var forwardArrow = /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('arrow forward', {
          visible: showForwardArrow
        }),
        onKeyPress: this.moveForward,
        onClick: this.moveForward,
        role: "button",
        tabIndex: "0"
      }, /*#__PURE__*/_react["default"].createElement(_svg["default"], {
        id: "chevron-light"
      }));

      var children = this.props.children;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('HorizontalScroll fullWidth', {
          showMobileArrows: showMobileArrows
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.setScrollRef,
        className: "scroll-content",
        onScroll: this.throttledHandleScroll
      }, children), backArrow, forwardArrow);
    }
  }]);

  return HorizontalScroll;
}(_react.Component);

HorizontalScroll.propTypes = {
  children: _propTypes["default"].node,
  showMobileArrows: _propTypes["default"].bool,
  scrollStepMultiply: _propTypes["default"].number
};
HorizontalScroll.defaultProps = {
  children: null,
  showMobileArrows: false,
  scrollStepMultiply: 1
};
var _default = HorizontalScroll;
exports["default"] = _default;